
/*
 *
 * Aml Actions
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 27-Giu-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {

  DO_LEGAL_REPRESENTATIVE: '@@Aml/do_legal_representative',
  DO_GET_SURVEY_INFO: '@@Aml/get_survey_info',
  DO_GET_DOCUMENT_TYPES: '@@Aml/do_get_document_types',
  DO_GET_DOCUMENT_ISSUERS: '@@Aml/do_get_document_issuers',
  DO_GET_LEGAL_FORMS: '@@Aml/get_legal_forms',
  DO_GET_NO_PROFIT_ORGANIZATIONS: '@@Aml/get_no_profit_organizations',
  DO_GET_ONLUS_CLASSES: '@@Aml/get_onlus_classes',
  DO_UPLOADED_DOCUMENT_FILES: '@@Aml/uploaded_document_files',
  DO_REMOVE_UPLOADED_DOCUMENT_FILE: '@@Aml/remove_uploaded_document_file',
  DO_GET_LEGAL_RELATIONS: '@@Aml/get_legal_relations',
  DO_UPDATE_LEGAL_OFFICE: '@@Aml/update_legal_office',
  DO_GET_SAE_CODES: '@@Aml/get_sae_codes',
  DO_GET_ATECO_CODES: '@@Aml/get_ateco_codes',
  DO_UPDATE_ADDITIONAL_DATA: '@@Aml/update_additional_data',
  DO_UPDATE_PERSONAL_DATA: '@@Aml/update_personal_data',
  DO_VERIFY_SECTION: '@@Aml/verify_section',
  DO_DISCARD_SURVEY_DRAFT: '@@Aml/discard_survey_draft',
  DO_UPDATE_ANOMALOUS_FIELDS: '@@Aml/update_anomalous_fields',
  DO_IS_RESET_LEGAL_FORM: '@@Aml/is_reset_legal_form',
  DO_UPDATE_LEGAL_REPRESENTATIVE: '@@Aml/update_legal_representative',
  DO_SUBMIT_AML: '@@Aml/submit_aml',
  DO_DOWNLOAD_SURVEY: '@@Aml/download_survey',
  DO_BENEFICIAL_OWNERS: '@@Aml/beneficial_owners',
  DO_UPDATE_BENEFICIAL_OWNERS: '@@Aml/update_beneficial_owners',
  DO_IS_RESET_OWNER: '@@Aml/is_reset_owner',
  DO_INDEX_BENEFICIAL_OWNERS: '@@Aml/index_beneficial_owners',
  DO_DELETE_BENEFICIAL_OWNER: '@@Aml/delete_beneficial_owner',
  DO_SAVE_UPLOAD_DOCUMENTS: '@@Aml/save_upload_documents',
  DO_GET_BENEFICIAL_RELATIONS: '@@Aml/get_beneficial_relations',
  // @generator action:route:type
  ...createRequestTypes('@@Aml', 'GET_SURVEY_INFO'),
  ...createRequestTypes('@@Aml', 'GET_DOCUMENT_TYPES'),
  ...createRequestTypes('@@Aml', 'GET_DOCUMENT_ISSUERS'),
  ...createRequestTypes('@@Aml', 'GET_LEGAL_FORMS'),
  ...createRequestTypes('@@Aml', 'GET_NO_PROFIT_ORGANIZATIONS'),
  ...createRequestTypes('@@Aml', 'GET_ONLUS_CLASSES'),
  ...createRequestTypes('@@Aml', 'UPLOADED_DOCUMENT_FILES'),
  ...createRequestTypes('@@Aml', 'GET_LEGAL_RELATIONS'),
  ...createRequestTypes('@@Aml', 'GET_SAE_CODES'),
  ...createRequestTypes('@@Aml', 'GET_ATECO_CODES'),
  ...createRequestTypes('@@Aml', 'GET_LEGAL_RELATIONS'),
  ...createRequestTypes('@@Aml', 'SUBMIT_AML'),
  ...createRequestTypes('@@Aml', 'DOWNLOAD_SURVEY'),
  ...createRequestTypes('@@Aml', 'SAVE_UPLOAD_DOCUMENTS'),
  ...createRequestTypes('@@Aml', 'GET_BENEFICAL_RELATIONS')
// @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------

// @generator action:route:request
/** @action request
* * Insert a description
* @name getBeneficalRelations
* @return {object} - The action object
*/
export const getBeneficalRelations = new MakeRequest('Aml', 'get_benefical_relations')
/** @action request
* * Insert a description
* @name saveUploadDocuments
* @return {object} - The action object
*/
export const saveUploadDocuments = new MakeRequest('Aml', 'save_upload_documents')
/** @action request
* * Insert a description
* @name downloadSurvey
* @return {object} - The action object
*/
export const downloadSurvey = new MakeRequest('Aml', 'download_survey')
/** @action request
* * Insert a description
* @name submitAml
* @return {object} - The action object
*/
export const submitAml = new MakeRequest('Aml', 'submit_aml')
/** @action request
* * Insert a description
* @name getAtecoCodes
* @return {object} - The action object
*/
export const getAtecoCodes = new MakeRequest('Aml', 'get_ateco_codes')
/** @action request
* * Insert a description
* @name getSaeCodes
* @return {object} - The action object
*/
export const getSaeCodes = new MakeRequest('Aml', 'get_sae_codes')
/** @action request
* * Insert a description
* @name getLegalRelations
* @return {object} - The action object
*/
export const getLegalRelations = new MakeRequest('Aml', 'get_legal_relations')
/** @action request
* * Insert a description
* @name uploadedDocumentFiles
* @return {object} - The action object
*/
export const uploadedDocumentFiles = new MakeRequest('Aml', 'uploaded_document_files')
/** @action request
* * Action to get survey info
* @name getSurveyInfo
* @return {object} - The action object
*/
export const getSurveyInfo = new MakeRequest('Aml', 'get_survey_info')
/** @action request
* * Insert a description
* @name getDocumentIssuers
* @return {object} - The action object
*/
export const getDocumentIssuers = new MakeRequest('Aml', 'get_document_issuers')
/** @action request
* * Insert a description
* @name getDocumentTypes
* @return {object} - The action object
*/
export const getDocumentTypes = new MakeRequest('Aml', 'get_document_types')
/** @action request
* * Insert a description
* @name getLegalForms
* @return {object} - The action object
*/
export const getLegalForms = new MakeRequest('Aml', 'get_legal_forms')
/** @action request
* * Insert a description
* @name getNoProfitOrganizations
* @return {object} - The action object
*/
export const getNoProfitOrganizations = new MakeRequest('Aml', 'get_no_profit_organizations')
/** @action request
* * Insert a description
* @name getOnlusClasses
* @return {object} - The action object
*/
export const getOnlusClasses = new MakeRequest('Aml', 'get_onlus_classes')

// @generator action:route
/** @action
* * Insert a description
* @name GetBeneficialRelations
* @return {object} - The payload object
*/
export const doGetBeneficialRelations = payload => createAction(actionTypes.DO_GET_BENEFICIAL_RELATIONS, { payload })
/** @action
* * Insert a description
* @name SaveUploadDocuments
* @return {object} - The payload object
*/
export const doSaveUploadDocuments = payload => createAction(actionTypes.DO_SAVE_UPLOAD_DOCUMENTS, { payload })
/** @action
* * Insert a description
* @name DeleteBeneficialOwner
* @return {object} - The payload object
*/
export const doDeleteBeneficialOwner = payload => createAction(actionTypes.DO_DELETE_BENEFICIAL_OWNER, { payload })
/** @action
* * Insert a description
* @name DownloadSurvey
* @return {object} - The payload object
*/
export const doDownloadSurvey = payload => createAction(actionTypes.DO_DOWNLOAD_SURVEY, { payload })
/** @action
* * Insert a description
* @name SubmitAml
* @return {object} - The payload object
*/
export const doSubmitAml = payload => createAction(actionTypes.DO_SUBMIT_AML, { payload })
/** @action
* * Insert a description
* @name IndexBeneficialOwners
* @return {object} - The payload object
*/
export const doIndexBeneficialOwners = payload => createAction(actionTypes.DO_INDEX_BENEFICIAL_OWNERS, { payload })
/** @action
* * Insert a description
* @name IsResetOwner
* @return {object} - The payload object
*/
export const doIsResetOwner = payload => createAction(actionTypes.DO_IS_RESET_OWNER, { payload })
/** @action
* * Insert a description
* @name UpdateBeneficialOwners
* @return {object} - The payload object
*/
export const doUpdateBeneficialOwners = payload => createAction(actionTypes.DO_UPDATE_BENEFICIAL_OWNERS, { payload })
/** @action
* * Insert a description
* @name doBeneficialOwners
* @return {object} - The payload object
*/
export const doBeneficialOwners = payload => createAction(actionTypes.DO_BENEFICIAL_OWNERS, { payload })
/** @action
* * Insert a description
* @name UpdateLegalRepresentative
* @return {object} - The payload object
*/
export const doUpdateLegalRepresentative = payload => createAction(actionTypes.DO_UPDATE_LEGAL_REPRESENTATIVE, { payload })
/** @action
* * Insert a description
* @name isResetLegalForm
* @return {object} - The payload object
*/
export const doIsResetLegalForm = payload => createAction(actionTypes.DO_IS_RESET_LEGAL_FORM, { payload })
/** @action
* * Insert a description
* @name doUpdateLegalOffice
* @return {object} - The payload object
*/
export const doUpdateLegalOffice = payload => createAction(actionTypes.DO_UPDATE_LEGAL_OFFICE, { payload })
/** @action
* * Insert a description
* @name doGetLegalRelations
* @return {object} - The payload object
*/
export const doGetLegalRelations = payload => createAction(actionTypes.DO_GET_LEGAL_RELATIONS, { payload })
/** @action
* * Insert a description
* @name doUploadedDocumentFiles
* @return {object} - The payload object
*/
export const doUploadedDocumentFiles = payload => createAction(actionTypes.DO_UPLOADED_DOCUMENT_FILES, { payload })
/** @action
* Remove staged upload metadata by document ID
* @name doRemoveUploadedDocumentFile
* @return {object} - The payload object
*/
export const doRemoveUploadedDocumentFile = payload => createAction(actionTypes.DO_REMOVE_UPLOADED_DOCUMENT_FILE, { payload })
/** @action
* * Insert a description
* @name doGetOnlusClasses
* @return {object} - The payload object
*/
export const doGetOnlusClasses = payload => createAction(actionTypes.DO_GET_ONLUS_CLASSES, { payload })
/** @action
* * Insert a description
* @name doGetLegalForms
* @return {object} - The payload object
*/
export const doGetLegalForms = payload => createAction(actionTypes.DO_GET_LEGAL_FORMS, { payload })
/** @action
* * Insert a description
* @name doGetNoProfitOrganizations
* @return {object} - The payload object
*/
export const doGetNoProfitOrganizations = payload => createAction(actionTypes.DO_GET_NO_PROFIT_ORGANIZATIONS, { payload })
/** @action
* * Action to start the "get survey info"
* @name GetSurveyInfo
* @return {object} - The payload object
*/
export const doGetSurveyInfo = payload => createAction(actionTypes.DO_GET_SURVEY_INFO, { payload })
/** @action
* * Insert a description
* @name doGetDocumentIssuers
* @return {object} - The payload object
*/
export const doGetDocumentIssuers = payload => createAction(actionTypes.DO_GET_DOCUMENT_ISSUERS, { payload })
/** @action
* * Insert a description
* @name doGetDocumentTypes
* @return {object} - The payload object
*/
export const doGetDocumentTypes = payload => createAction(actionTypes.DO_GET_DOCUMENT_TYPES, { payload })
/** @action
* * Insert a description
* @name doLegalRepresentative
* @return {object} - The payload object
*/
export const doLegalRepresentative = payload => createAction(actionTypes.DO_LEGAL_REPRESENTATIVE, { payload })
/** @action
* * Insert a description
* @name doGetSaeCodes
* @return {object} - The payload object
*/
export const doGetSaeCodes = payload => createAction(actionTypes.DO_GET_SAE_CODES, { payload })
/** @action
* * Insert a description
* @name doGetAtecoCodes
* @return {object} - The payload object
*/
export const doGetAtecoCodes = payload => createAction(actionTypes.DO_GET_ATECO_CODES, { payload })
/** @action
* * Insert a description
* @name doUpdateAdditionalData
* @return {object} - The payload object
*/
export const doUpdateAdditionalData = payload => createAction(actionTypes.DO_UPDATE_ADDITIONAL_DATA, { payload })
/** @action
* @name doUpdatePersonalData
* @return {object} - The payload object
*/
export const doUpdatePersonalData = (payload, callback) => createAction(actionTypes.DO_UPDATE_PERSONAL_DATA, { payload, meta: { callback } })
export const doVerifySection = payload => createAction(actionTypes.DO_VERIFY_SECTION, { payload })
export const doDiscardSurveyDraft = () => createAction(actionTypes.DO_DISCARD_SURVEY_DRAFT)
/** @action
* @name doUpdateAnomalousFields
* @return {object} - The payload object
*/
export const doUpdateAnomalousFields = (payload, callback) => createAction(actionTypes.DO_UPDATE_ANOMALOUS_FIELDS, { payload, meta: { callback } })
